module.exports = __webpack_public_path__ + "static/media/NarroginObserver-devicecomp-min@2x.f9525ef7.png";